import { Tabs } from 'aui';
import React from 'react';
import { SupportIconTitleNode } from '../Icon/parser';
import type { MdComponentIndexProps } from '../type';
import { mapSpecChildrenFactory } from '../utils/mapSpecChildren';
import { MarkdownTab } from './Tab';
import { MarkdownTabItem } from './TabItem';
import './Tabs.less';

type Tab = NonNullable<React.ComponentProps<typeof Tabs>['items']>[number];

const mapAcc = mapSpecChildrenFactory(MarkdownTab);
const mapItemAcc = mapSpecChildrenFactory(MarkdownTabItem);
export function MarkdownTabs({
  children,
  size,
  tabPosition,
  ...props
}: React.PropsWithChildren<
  {
    size?: 'small' | 'large' | 'middle';
    tabPosition?: 'top' | 'bottom' | 'left' | 'right';
  } & MdComponentIndexProps
>) {
  const tabChildren = mapAcc(children, ({ title, default: defaultActiveKey }, key, child) => {
    return {
      key: String(key),
      defaultActiveKey: Boolean(defaultActiveKey),
      label: <SupportIconTitleNode title={title} />,
      children: <div className="markdown-child-root">{child}</div>,
    } as Tab & {
      defaultActiveKey?: boolean;
    };
  });
  const tabItemChildren =
    tabChildren.length > 0
      ? tabChildren
      : mapItemAcc(children, ({ label, default: defaultActiveKey }, key, child) => {
          return {
            key: String(key),
            defaultActiveKey: Boolean(defaultActiveKey),
            label: <SupportIconTitleNode title={label} />,
            children: <div className="markdown-child-root">{child}</div>,
          } as Tab & {
            defaultActiveKey?: boolean;
          };
        });
  return (
    <div
      data-markdown-component="x-tabs-container"
      data-first={props['data-first']}
      data-last={props['data-last']}
    >
      <Tabs
        size={size}
        tabPosition={tabPosition}
        animated={false}
        items={tabItemChildren}
        defaultActiveKey={tabItemChildren.find((item) => item.defaultActiveKey)?.key}
      />
    </div>
  );
}

MarkdownTabs.attributes = ['size', 'tabPosition'] as string[];
